'use client';

import type { FC, PropsWithChildren } from 'react';
import { AiBrainHelp } from '@eqi-investimentos/icons/web';
import { Flex, Link, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { appConfig } from '@/config/app';
import { getRandomBackground } from '@/utils/number';

export const NoAuthTemplate: FC<PropsWithChildren> = ({ children }) => {
  const randomNumber = getRandomBackground();
  const t = useT();

  return (
    <Flex
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      w="100vw"
      h="100vh"
      bgImage={`url('/assets/backgrounds/image_${randomNumber}.png')`}
      bgSize="cover"
      bgRepeat="no-repeat"
    >
      <Flex
        as={Link}
        href={appConfig.support.whatsAppLink}
        target="_blank"
        rel="noopener noreferrer"
        position="absolute"
        top="3xl"
        right="3xl"
        gap="xs"
        color="content.alwaysLight"
      >
        <AiBrainHelp boxSize="1.5rem" />
        <Text size="l">{t('screens.login.help.title')}</Text>
      </Flex>
      {children}
    </Flex>
  );
};
